module.exports = __webpack_public_path__ + "static/media/infocamere.698f64cd.png";